import React, { useEffect, useState } from "react";
import api, { fmtErr } from "../../lib/api";
import { fmtEUR, fmtDate } from "../../lib/format";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { toast } from "sonner";

const Row = ({ l, v, strong }) => (<div className="flex justify-between text-sm"><span className="text-muted-foreground">{l}</span><span className={strong ? "font-bold" : "font-medium"}>{v}</span></div>);

export default function LiquidaDialog({ contratto, onClose }) {
  const [p, setP] = useState(null);
  const [data, setData] = useState(new Date().toISOString().slice(0, 10));
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (contratto) api.get(`/investments/${contratto.id}/liquidazione-anteprima`).then((r) => setP(r.data)).catch((e) => toast.error(fmtErr(e.response?.data?.detail))); else setP(null); }, [contratto]);
  const go = async () => {
    setBusy(true);
    try { const r = await api.post(`/investments/${contratto.id}/liquida`, { data_bonifico: data }); toast.success(`Liquidato: netto ${fmtEUR(r.data.netto_bonificato)} · F24 ${fmtEUR(r.data.ritenuta)} entro ${fmtDate(r.data.scadenza_f24)}`); onClose(true); }
    catch (e) { toast.error(fmtErr(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!contratto} onOpenChange={() => onClose(false)}>
      <DialogContent data-testid="liquida-dialog">
        <DialogHeader><DialogTitle>Liquida contratto {contratto?.codice}</DialogTitle></DialogHeader>
        {p && (
          <div className="space-y-2">
            <Row l="Apporto da restituire" v={fmtEUR(p.capitale_da_restituire)} />
            <Row l="Quota utili lorda" v={fmtEUR(p.quota_lorda)} />
            <Row l={`Ritenuta ${p.pct}% sulla quota utili`} v={`− ${fmtEUR(p.ritenuta_quota)}`} />
            {p.ritenuta_riportata > 0 && <Row l="Ritenuta riportata da utili reinvestiti" v={`− ${fmtEUR(p.ritenuta_riportata)}`} />}
            <div className="border-t pt-2"><Row l="Netto da bonificare all'associato" v={fmtEUR(p.netto_da_bonificare)} strong /></div>
            <Row l="F24 da versare (tributo 1030)" v={`${fmtEUR(p.totale)} — matura al bonifico, scadenza il 16 del mese successivo`} />
            {p.gia_liquidato && <div className="text-xs text-destructive">Questo contratto risulta già liquidato.</div>}
            <div><Label className="text-xs">Data del bonifico</Label><Input type="date" value={data} onChange={(e) => setData(e.target.value)} data-testid="liquida-data" /></div>
            <p className="text-xs text-muted-foreground">Il bonifico netto finisce in «Pagamenti da autorizzare» (ricevi l'email con il link Autorizza). Dopo il tuo OK generi il file SEPA per l'home banking; quando il bonifico è eseguito il contratto passa a concluso e <b>solo allora</b> matura la ritenuta: l'F24 viene generato e messo in coda con scadenza il 16 del mese successivo.</p>
          </div>)}
        <DialogFooter><Button variant="outline" onClick={() => onClose(false)}>Annulla</Button><Button onClick={go} disabled={busy || !p || p.gia_liquidato} data-testid="liquida-confirm">Conferma liquidazione</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
